import { Tab, Tabs } from "@blueprintjs/core"
import { observer } from "mobx-react"
import { Page } from "modules/common/components/page/Page"
import func from "modules/orders-manage/functionalities"
import { menuItems } from "modules/root/components/menu/MainMenu"
import { canAny } from "modules/session/auth/access"
import { SessionType } from "modules/session/auth/models/session"
import React from "react"
import { OrderQuestionStoreType } from "../models/store"
import styles from "./OrderQuestionsPage.module.scss"
import { QuestionsTab } from "./Tab"

const menu = menuItems()

export const OrderQuestionsPage = observer(
  class extends React.PureComponent<OrderQuestionsPageProps> {
    // constructor(props: OrderQuestionsPageProps) {
    //   super(props);

    //   props.store.load();
    // }
    componentDidMount() {
      document.title = menu.orderQuestions.label
    }

    render() {
      const { store, session } = this.props

      return (
        <Page className={styles.page}>
          <Tabs
            className={`${styles.tabs} planr-tabs-navigation`}
            id="OrderQuestionsPage"
            selectedTabId="1"
            renderActiveTabPanelOnly={true}
          >
            <Tab
              id="1"
              title={menu.orderQuestions.label}
              panel={
                <QuestionsTab
                  store={store}
                  currentUserId={session.userId}
                  canManage={canAny([func.ORDERS_QUESTION_EDIT, func.ORDERS_QUESTION_FULL_ACCESS], session.access)}
                  isActiveTab
                  canAddQuestion={canAny([func.ORDERS_QUESTION_EDIT, func.ORDERS_QUESTION_FULL_ACCESS], session.access)}
                />
              }
            />
          </Tabs>
        </Page>
      )
    }
  }
)

interface OrderQuestionsPageProps {
  store: OrderQuestionStoreType
  session: SessionType
}
